import PropTypes from 'prop-types';
// @mui
import { Box, Card, IconButton, Stack, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
// utils
import { useState } from 'react';
// components
import Iconify from '../../../components/iconify';
import ConditionSkeleton from '../../../components/skeleton/ConditionSkeleton';

// ----------------------------------------------------------------------

HomeWidgetSummary.propTypes = {
  sx: PropTypes.object,
  title: PropTypes.string,
  total: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  percent: PropTypes.number,
  fetching: PropTypes.bool,
  showInfo: PropTypes.bool,
};

export default function HomeWidgetSummary({
  title,
  percent,
  total,
  showInfo = false,
  fetching,
  sx,
  ...other
}) {
  const [showValue, setShowValue] = useState(showInfo);

  return (
    <Card
      sx={{
        display: 'flex',
        alignItems: 'center',
        p: {
          xs: 2,
          md: 3,
        },
        borderLeft: (theme) => `solid 4px ${theme.palette.success.main}`,
        ...sx,
      }}
      {...other}
    >
      <Box sx={{ flexGrow: 1, height: other?.height || 80 }}>
        <Typography variant="subtitle2" paragraph color="text.secondary" noWrap>
          {title}
        </Typography>

        <Stack direction="row" alignItems="center" spacing={1} justifyContent="space-between">
          <ConditionSkeleton loading={fetching}>
            <Typography
              variant="subtitle1"
              sx={{
                filter: showValue ? 'none' : 'blur(12px)',
                fontSize: other?.fontSize && other?.fontSize,
                transition: (theme) => theme.transitions.create('filter'),
              }}
            >
              {total}
            </Typography>
          </ConditionSkeleton>
          <ConditionSkeleton loading={fetching}>
            <IconButton size="small" onClick={() => setShowValue(!showValue)} edge="end">
              <Iconify icon={showValue ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
            </IconButton>
          </ConditionSkeleton>
        </Stack>
      </Box>
    </Card>
  );
}

// ----------------------------------------------------------------------

TrendingInfo.propTypes = {
  percent: PropTypes.number,
};

function TrendingInfo({ percent }) {
  return (
    <Stack direction="row" alignItems="center" sx={{ mt: 2, mb: 1 }}>
      <Iconify
        icon={percent < 0 ? 'eva:trending-down-fill' : 'eva:trending-up-fill'}
        sx={{
          mr: 1,
          p: 0.5,
          width: 24,
          height: 24,
          borderRadius: '50%',
          color: 'success.main',
          bgcolor: (theme) => alpha(theme.palette.success.main, 0.16),
          ...(percent < 0 && {
            color: 'error.main',
            bgcolor: (theme) => alpha(theme.palette.error.main, 0.16),
          }),
        }}
      />
    </Stack>
  );
}
